import * as trace from 'owa-trace';
import getTableToItemRelationKey from 'mini-mail-list-store/lib/utils/getTableToItemRelationKey';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { action } from 'satcheljs/lib/legacy';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { lazyRemoveMeetingMessagesFromStore } from 'mini-mail-list-rsvp';
import { tryRemoveItemFromMailStore } from './helpers/tryRemoveItemFromMailStore';

export default action('removeItemData')(function removeItemData(
    itemId: string,
    tableView: TableView
) {
    const item = getMailStore().items.get(itemId);
    if (!item) {
        trace.errorThatWillCauseAlert("Item doesn't exist in mailStore: removeItemData");
        return;
    }
    const relationKey = getTableToItemRelationKey(item.ItemId.Id, tableView.id);
    const listViewStore = getListViewStore();

    if (!listViewStore.tableViewItemRelations.has(relationKey)) {
        trace.errorThatWillCauseAlert(
            "TableItemRelation doesn't exist for given item: removeItemData"
        );
        return;
    }

    // 1. If the item being removed is selected, remove item from selected item ids.
    /*
     *  This should be done before we delete tableViewItemRelations as this sets
     *  isSelected property on it.
     */
    tableView.selectedItemsIds.delete(itemId);

    // 2. Remove the item from table-item relation
    listViewStore.tableViewItemRelations.delete(relationKey);

    // 3. Remove the item from meeting messages store
    lazyRemoveMeetingMessagesFromStore.importAndExecute([itemId]);

    // 4. Try deleting the item if it's no longer referenced
    tryRemoveItemFromMailStore(itemId);
});
